import { UIGameSpriteHandler } from '../../UIGameSpriteHandler.ts';
import { UIHoverActionController } from './UIHoverActionController.ts';
import { PieceTypes } from '@colonist/game-base-types';
import { getCardsForPiece } from '@colonist/game-card-types';
import { TileCornerBuildingType } from '@colonist/game-states';
import { GameStateEnums } from '../../../../../shared/GameEnums.ts';
export class UIKnightPlacementHoverActionController extends UIHoverActionController {
    onEvent(data, eventType) {
        super.onEvent(data, eventType);
        switch(eventType){
            case GameStateEnums.UIGameEventEnums.KnightStateUpdated:
                this.updateState();
                break;
            default:
                break;
        }
    }
    getBankActionAmount(locationCornerIndex) {
        return this.knightPlayerValidator.getAmountOfKnightsOfLevelThatCanBePlacedOnMap(1);
    }
    updateState() {
        const useResources = true;
        const action = this.knightPlayerValidator.canPlayerPlaceNewKnight(useResources);
        this.updateHoverLocations(action.validHoverLocations, action.canTakeAction);
    }
    getTexture(locationCornerIndex) {
        const knightTexture = TileCornerBuildingType.KnightInactiveLevel1;
        return UIGameSpriteHandler.getKnightForPlayer(this.uiGameManager.gameController.myColor, knightTexture);
    }
    constructor(uiGameManager, knightPlayerValidator){
        super(uiGameManager);
        this.isCornerAction = true;
        this.resources = getCardsForPiece(PieceTypes.Knight);
        this.action = (index)=>this.uiGameManager.socketGameSend.confirmPlaceKnightSkippingSelection(index);
        this.uiGameManager.mapController.hoverController.registerTileCornerHoverAction(this);
        this.knightPlayerValidator = knightPlayerValidator;
    }
}
